/**
 * @generated SignedSource<<42835ba078b81b9ff9ed3f50116987d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignEmailLayoutToTemplateInput = {
  emailLayoutIdentifier?: string | null | undefined;
  id: string;
};
export type EmailTemplateDetailsViewAssignLayoutMutation$variables = {
  input: AssignEmailLayoutToTemplateInput;
};
export type EmailTemplateDetailsViewAssignLayoutMutation$data = {
  readonly assignEmailLayoutToTemplate: {
    readonly emailLayout: {
      readonly emailLayoutIdentifier: string;
      readonly id: string;
      readonly name: string;
      readonly textContent: string;
    } | null | undefined;
    readonly id: string;
  };
};
export type EmailTemplateDetailsViewAssignLayoutMutation = {
  response: EmailTemplateDetailsViewAssignLayoutMutation$data;
  variables: EmailTemplateDetailsViewAssignLayoutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailTemplate",
    "kind": "LinkedField",
    "name": "assignEmailLayoutToTemplate",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "EmailLayout",
        "kind": "LinkedField",
        "name": "emailLayout",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailLayoutIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "textContent",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailTemplateDetailsViewAssignLayoutMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailTemplateDetailsViewAssignLayoutMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9d6b4476bc5f9b0092719188e4476d65",
    "id": null,
    "metadata": {},
    "name": "EmailTemplateDetailsViewAssignLayoutMutation",
    "operationKind": "mutation",
    "text": "mutation EmailTemplateDetailsViewAssignLayoutMutation(\n  $input: AssignEmailLayoutToTemplateInput!\n) {\n  assignEmailLayoutToTemplate(input: $input) {\n    id\n    emailLayout {\n      id\n      emailLayoutIdentifier\n      name\n      textContent\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5fef28f6dbee920996b70c837ca1ca68";

export default node;
